const init = () => {
    // my details newsletter subscribe
    var $component = $('.newsletter-subscribe');
    if ($component.length < 1) return;
    var $btns = $component.find('button');
    var $form = $component.find('.newsletter-subscribe__form');
    $btns.click(function() {
        var isAgree = $(this).hasClass('newsletter-subscribe__btn--yes');
        var $agree = $btns.filter('.newsletter-subscribe__btn--yes');
        var $disagree = $btns.filter('.newsletter-subscribe__btn--no');
        if (isAgree) {
            $agree.addClass('is-active');
            $disagree.removeClass('is-active');
        } else {
            $agree.removeClass('is-active');
            $disagree.addClass('is-active');
        }
        PubSub.publish('newsletter-subscribe.changed', isAgree);
    })
}

export default init;